import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  constructor(private sessionService: SessionService) {}

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = this.sessionService.token;
    let id = this.sessionService.id;
    let modified;
    const existingToken = httpRequest.headers.get("authorization");
    if (!existingToken && id && token) {
      modified = httpRequest.clone({ setHeaders: { id: id, Authorization: token } });
    } else {
      modified = httpRequest;
    }
    return next.handle(modified);
  }

}
